import React from 'react'
import Select, { components } from 'react-select'
import colourStyles from "./reactSelectStyles"
import CreatableSelect from 'react-select/creatable';

export const CustomSingleSelect = ({ input, label = "", options, onChange, clearable, placeholder, styles = colourStyles, dropdownIndicator = null, indicatorSeparator = null, isMulti = false, value = null, otherProps = {}, touchValidate = true, meta: { touched, error, warning } }) => {
  return (
    <div>
      {label && label.length > 0 &&
        <label>{label}</label>
      }
      <Select
        onChange={onChange || input.onChange}
        clearable={clearable || true}
        styles={styles}
        placeholder={placeholder}
        components={{
          DropdownIndicator: () => dropdownIndicator,
          IndicatorSeparator: () => indicatorSeparator
        }}
        value={value || input.value}
        options={options}
        menuPlacement="auto"
        isMulti={isMulti}
        // menuPortalTarget={document.body}
        {...otherProps}
      />
      {touchValidate ? (touched && (error && (<span className="error-input">{error}</span>) || (warning && <span>{warning}</span>))) : (error && (<span className="error-input">{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  )
}

export const CustomValueContainer = ({ children, ...props }) => {
  const [value, input, ...rest] = children;
  const { selectProps } = props;
  const { suffix } = selectProps
  return (
    <components.ValueContainer {...props}>
      {value}
      {input}
      <span style={{ marginLeft: 8, position: 'absolute', right: "8px", display: 'flex', alignItems: 'center' }}>
        {suffix ? suffix : null}
      </span>
      {rest}
    </components.ValueContainer>
  );
};

export const CustomCreatableSingleSelect = ({ isClearable = true, input, label = "", options, onChange, clearable, placeholder, styles = colourStyles, dropdownIndicator = null, indicatorSeparator = null, isMulti = false, value = null, otherProps = {}, touchValidate = true, meta: { touched, error, warning } }) => {
  return (
    <div>
      {label && label.length > 0 &&
        <label>{label}</label>
      }
      <CreatableSelect
        onChange={onChange || input.onChange}
        clearable={clearable || true}
        styles={styles}
        placeholder={placeholder}
        components={{
          DropdownIndicator: () => dropdownIndicator,
          IndicatorSeparator: () => indicatorSeparator
        }}
        value={value || input.value}
        options={options}
        menuPlacement="auto"
        isMulti={isMulti}
        isClearable
        // menuPortalTarget={document.body}
        {...otherProps}
      />
      {touchValidate ? (touched && (error && (<span className="error-input">{error}</span>) || (warning && <span>{warning}</span>))) : (error && (<span className="error-input">{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  )
}